module.exports = __webpack_public_path__ + "static/media/moved-icon.f30f5d0a.svg";